import { useSnackbar } from 'notistack';
import { useTranslation } from 'react-i18next';
import { useCallback } from 'react';

export const useToast = () => {
    const { enqueueSnackbar } = useSnackbar();
    const { t } = useTranslation();

    const showError = useCallback(
        (message: string, params: Record<string, any> = {}) => {
            enqueueSnackbar(
                t(message, {
                    ...params,
                    ns: 'message',
                }),
                {
                    variant: 'error',
                }
            );
        },
        [enqueueSnackbar, t]
    );

    const showSuccess = useCallback(
        (message: string, params: Record<string, any> = {}) => {
            enqueueSnackbar(
                t(message, {
                    ...params,
                    ns: 'message',
                }),
                {
                    variant: 'success',
                }
            );
        },
        [enqueueSnackbar, t]
    );

    return {
        showError,
        showSuccess,
    };
};
